import React from 'react'
import RenderIf from "src/components/views/mkt04/RenderIf";
import {DefaultButton, PrimaryButton, SecondaryButton} from "src/components/views/mkt04/Button/styled";
import {IconButton} from "src/components/views/mkt04/Button/IconButton";


export const Spinner = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        style={{ animation: 'spin 1s linear infinite' }}
    >
        <circle
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
            strokeLinecap="round"
            strokeDasharray="31.416"
            strokeDashoffset="31.416"
            style={{
                animation: 'spin 1s ease-in-out infinite',
                transformOrigin: 'center'
            }}
        />
        <style>{`
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `}</style>
    </svg>
);
interface ButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
    name?: string
    onClick?: React.MouseEventHandler<HTMLButtonElement>
    renderIf?: boolean
    disabled?: boolean
    children?: React.ReactNode
    backgroundColor?: string
    isLoading?: boolean
    style?: React.CSSProperties
    icon?: React.ReactNode
    iconSrc?: string
    iconAlt?: string
    iconPosition?: 'left' | 'right'
    iconSize?: number
    iconGap?: number
    type?: 'button'
}

const OtpCertRequestButton = (props: ButtonProps) => {
  const { name = '인증번호 발송', renderIf = true, isLoading = false, disabled, ...remainProps } = props
  return (
    <RenderIf when={renderIf}>
      <IconButton
        {...remainProps}
        className="btn_send_sms"
        name={name}
        disabled={disabled || isLoading}
        isLoading={isLoading}
      />
    </RenderIf>
  )
}

const ReTryOtpCertRequestButton = (props: ButtonProps) => {
  const { name = '재발송', renderIf = true,  isLoading = false, disabled, ...remainProps } = props
  return (
    <RenderIf when={renderIf}>
      <PrimaryButton {...remainProps} className="btn_resend_sms"  disabled={disabled || isLoading}  isLoading={isLoading}>
          {isLoading && <Spinner />}
          {isLoading ? '' : name}
      </PrimaryButton>
    </RenderIf>
  )
}

const JoinSubmitButton = (props: ButtonProps) => {
    const {
      name = '휴대폰가족보호 유료부가서비스가입',
          isLoading = false,
          disabled,
          renderIf = true,
          children,
          icon, iconSrc, iconAlt = '',
          iconPosition = 'right', 
          iconSize = 24, 
          iconGap = 8,
          ...remainProps
    } = props
        return (
          <RenderIf when={renderIf}>
                <IconButton
                  {...remainProps}
                  className="btn_signup"
                  disabled={disabled || isLoading}
                  isLoading={isLoading}
                  icon={icon}
                  iconSrc={iconSrc}
                  iconAlt={iconAlt}
                  iconPosition={iconPosition}
                  iconSize={iconSize}
                  iconGap={iconGap}
                >
                  {isLoading ? <Spinner/> : (children ?? name)}
                </IconButton>
          </RenderIf>
    )
    }

const MvnoTermsSubmitButton = (props: ButtonProps) => {
    const { name = '동의 및 인증번호 받기',  isLoading = false, disabled, renderIf = true, ...remainProps } = props
    return (
        <RenderIf when={renderIf}>
            <PrimaryButton {...remainProps}  disabled={disabled || isLoading}  isLoading={isLoading}>
                {isLoading && <Spinner />}
                {isLoading ? '' : (name || '동의 및 인증번호 받기')}
            </PrimaryButton>
        </RenderIf>
    )
}

const CancelResetButton = (props: ButtonProps) => {
  const { name = '취소', renderIf = true,  isLoading = false, disabled, ...remainProps } = props
  return (
    <RenderIf when={renderIf}>
      <DefaultButton {...remainProps} className="btn_cancel"   disabled={disabled || isLoading}  isLoading={isLoading}>
          {isLoading && <Spinner />}
          {isLoading ? '' : name}
      </DefaultButton>
    </RenderIf>
  )
}
export const Button = {
  Default: DefaultButton,
  Primary: PrimaryButton,
  Secondary: SecondaryButton,
  JoinSubmit: JoinSubmitButton,
  OtpCertRequest: OtpCertRequestButton,
  RetryOtpCertRequest: ReTryOtpCertRequestButton,
  CancelReset: CancelResetButton,
  MvnoTermsSubmit:MvnoTermsSubmitButton
}
